import React from 'react'
import styled from "styled-components"

interface Props {
  size?: number
  className?: string
  name?: string
  bold?: boolean
  style?: {}
}

const StyledIcon = styled.span<Props>`
  ${p => p.size ? `font-size: ${p.size}px` : ''}
  font-weight: ${p => p.bold ? 'bold' : 'normal'};
`
const Icon: React.FC<Props> = ({ name, children, className = '', ...rest }) => {
  return (
    <StyledIcon {...rest} className={`icon icon-${name} ${className}`}>
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
      <span className="path5"></span>
      <span className="path6"></span>
      <span className="path7"></span>
      <span className="path8"></span>
      <span className="path9"></span>
      <span className="path10"></span>
      <span className="path11"></span>
      <span className="f-family-sans-serif">{children}</span>
    </StyledIcon>
  )
}

export default Icon
